import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, Input, EventEmitter, Output, ChangeDetectorRef, SimpleChanges } from '@angular/core';
import { ClientService, TimeconversionService, ToastMessageService } from '@fitness-force/api';
import { ClientStatus } from '@fitness-force/enum';
import { child, ClientById, STAGE_MASTER_MODEL, TENANTSINTERFACE } from '@fitness-force/models';
import { ShortNamePipe } from '@fitness-force/pipes/short-name';
import { BookAppointmentComponent, timeLineService } from '@fitness-force/shared';
import { Store } from '@ngrx/store';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { STAGE_MASTER_STATE, TENANTS_INFO } from 'apps/ff-frontend/src/app/state/app.state';
import { AvatarModule } from 'primeng/avatar';
import { MessageModule } from 'primeng/message';

import { PopoverModule } from 'primeng/popover';
import { SkeletonModule } from 'primeng/skeleton';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { ProspectListActionsComponent } from '../prospect-list-actions/prospect-list-actions.component';
import Statsig from 'statsig-js';
import { CONSTANTS_DATA } from '@fitness-force/constants';
import { ClientProfileDetailsTabComponent } from '../client-profile-details-tab/client-profile-details-tab.component';
import { StyleClassModule } from 'primeng/styleclass';
import { TooltipModule } from 'primeng/tooltip';
import { SendBulkEmailComponent, SendBulkSmsComponent, SendWhatsappComponent } from '@fitness-force/campaigns';
import { SelectModule } from 'primeng/select';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { StaffStoreService } from 'libs/api/src/lib/staff/staff-store.service';

@Component({
  selector: 'client-profile-left-side',
  templateUrl: './client-profile-left-side.component.html',
  styleUrls: ['./client-profile-left-side.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule,
    FormsModule,
    SkeletonModule,
    AvatarModule,
    MessageModule,
    PopoverModule,
    SkeletonModule,
    StyleClassModule,
    ShortNamePipe,
    ProspectListActionsComponent,
    BookAppointmentComponent,
    SendBulkSmsComponent,
    SendBulkEmailComponent,
    SendWhatsappComponent,
    TooltipModule,
    SelectModule,
    ClientProfileDetailsTabComponent,
    ButtonModule,
    TranslateModule]})
export class ClientProfileLeftSideComponent implements OnInit {
  @Input('clientDetails') client : ClientById = {} as ClientById;
  @Input('tenantId') tenantId = 0;
  @Input('showSkeleton') showSkeleton$ = new BehaviorSubject<boolean>(true);
  @Input('showCloseIcon') showCloseIcon$ = new BehaviorSubject<boolean>(true);
  @Output('closeClientSidebar') closeClientSidebar: EventEmitter<boolean> = new EventEmitter();
  @Output() changeEvent = new EventEmitter();

  currentTenantId = 0;
  showClientDetails: boolean = false;
  showClientSidebar: boolean = false;
  allClients$ = new BehaviorSubject<ClientById>({} as ClientById);
  selectedMenu: any;
  getAccessTenantList$: Observable<any> | any | null;
  allTenants: any = [];
  selectedTenant: any;
  allStaffs: any = [];
  clientIds: number[] = [];
  showOrganization = false;
  showAddCreditButton: boolean = false;
  showSendSMs: boolean = false;
  showSendEmail: boolean = false;
  toggleSendEmailDialog$ = new BehaviorSubject<boolean>(false);
  toggleCreateSmsDialog$ = new BehaviorSubject<boolean>(false);
  toggleSendWhatsAppDialog$ = new BehaviorSubject<boolean>(false);
  isBlackListed = new BehaviorSubject<boolean>(false);
  currentTenantClient: boolean = true;
  toggleEditProfileDialog$ = new BehaviorSubject<boolean | null>(false);
  showBookAppointmentPopup: boolean = false;
  attachmentsModal:boolean =false;
  SelectedClient = new BehaviorSubject<ClientById>({} as ClientById); 
  clientInfos = new BehaviorSubject<any[]>([]);
  selectedClientInfo: {name: string, value: string } = {name: '', value: ''};
  parentClient:ClientById ={} as ClientById;
  childs:child[] = [];
  relationDetails: any[] = [];

  showDeleteDigitalPass: boolean = false;

  constructor(private clientService: ClientService, private store: Store, 
     private timeService: TimeconversionService, private cd: ChangeDetectorRef, 
     private translate: TranslateService, public toastMessageService: ToastMessageService,
    private staffStoreService: StaffStoreService) {
   }

  ngOnInit(): void {
    if (Statsig.checkGate("client_organisation_link")) {
      this.showOrganization = true;
    }
    if (Statsig.checkGate("customer_credit_balance")) {
      this.showAddCreditButton = true;
    }

    if (Statsig.checkGate("show_sms")) {
      this.showSendSMs = true;
    }

    if (Statsig.checkGate("show_email")) {
      this.showSendEmail = true;
    }

    if (Statsig.checkGate("show_digital_keyfob")) {
      this.showDeleteDigitalPass = true;
    }

    this.store.select(TENANTS_INFO).subscribe((tenant: TENANTSINTERFACE) => {
      this.currentTenantId = tenant.selected_tenant.id;
      this.allTenants = tenant.all_tenant;
      this.selectedTenant = tenant.selected_tenant;
    });
    // this.store.select(STAFF_STATE).subscribe((staff: STATE_STAFF_LIST) => {
    //   this.allStaffs = staff.staffListAll;
    // });
    this.staffStoreService.getAllStaff(this.tenantId).subscribe((staff) => {
      this.allStaffs = staff;
    });
    
    // Initialize relation details
    this.setRelationDetails();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['client'] && changes['client'].currentValue != changes['client'].previousValue) {
      this.clientInfos.next([]);
      this.setClientInfo();
      this.setRelationDetails();
    }
  }

  setClientInfo(){
    this.clientInfos.next([]);
    if(this.client && this.client.id) {
      this.clientInfos.next([...this.clientInfos.value, {name: 'Client ID', value: this.client.id.toString()}]);
      if(this.client.current_keyfob) this.clientInfos.next([...this.clientInfos.value, {name: 'KeyFob ID', value: this.client.current_keyfob}]);
      if(this.client.external_cms_id) this.clientInfos.next([...this.clientInfos.value, {name: 'External CMS ID', value: this.client.external_cms_id}]);
      
      if(this.clientInfos.value.length > 0) {
        this.selectedClientInfo = this.clientInfos.value[0];
      }
    }
    this.cd.detectChanges();
  }

  getClientDetails() {
    this.showSkeleton$.next(true);
    this.clientService.getClientByIdNew(this.client.id).subscribe({
      next: (res) => {
        this.client = res;
        this.allClients$.next(this.client);
        this.showSkeleton$.next(false);
        this.setClientInfo();
        this.setRelationDetails();
        this.cd.detectChanges();
      },
      error: (error: any) => {
        this.showSkeleton$.next(false);
        this.cd.detectChanges();
      }
    });
  }

  get isCurrentTenantClient() {
    if (this.client != undefined && (this.client.client_status == ClientStatus.Client || this.client.client_status.toString() == ClientStatus[ClientStatus.Client])) {
      if (this.tenantId == this.client.home_club_tenant_id) this.currentTenantClient = true;
      else this.currentTenantClient = false;
    }
    else if (this.client != undefined && (this.client.client_status == ClientStatus.Prospect || this.client.client_status.toString() == ClientStatus[ClientStatus.Prospect]
    || this.client.client_status == ClientStatus.Trial || this.client.client_status.toString() == ClientStatus[ClientStatus.Trial])) {
      if (this.tenantId == this.client.createdin_tenant_id) this.currentTenantClient = true;
      else this.currentTenantClient = false;
    }
    else {
      if (this.client != undefined && this.tenantId == this.client.createdin_tenant_id && this.tenantId == this.client.home_club_tenant_id) this.currentTenantClient = true;
      else if (this.client != undefined && this.tenantId == this.client.home_club_tenant_id) this.currentTenantClient = true;
      else this.currentTenantClient = false;
    }
    return this.currentTenantClient;
  }

  clientStatus(client: any): string {
    if (client && client.client_status)
      return this.clientService.getClientStatusHtml(client.client_status.toString());
    else
      return '';
  }

  memberSince(fromDate: string) {
    return timeLineService(this.timeService.ConvertUTCToLocalDateTime(fromDate));
  }

  getStageStatus(): Observable<string> {
    let stageMaster = this.client.stage_master.find(s => s.tenant_id == this.currentTenantId);
    return this.store.select(STAGE_MASTER_STATE).pipe(
      map((value: STAGE_MASTER_MODEL[]) => value.find(obj => obj.id == stageMaster?.stage_master_id)?.name_primary_language!)
    );
  }

  isDefaultDate(date: string): boolean {
    let year = new Date(date).getFullYear();
    if (year == 9999 || year == 1) return true;
    else return false;
  }

  isDefaultBirthDayDate(date: string): boolean {
    if(date  == null) return true;
    let year = new Date(date).getFullYear();
    if (year == 9999 || year == 1) return true;
    else return false;
  }

  isProspect(status: any): Boolean {
    let cltStatus = ClientStatus[status as keyof typeof ClientStatus];
    return cltStatus == ClientStatus.Prospect || status.toString() == ClientStatus[ClientStatus.Prospect]
  }

  isNonMember(status: any): Boolean {
    let cltStatus = ClientStatus[status as keyof typeof ClientStatus];
    return cltStatus == ClientStatus.ClientNonMember || status.toString() == ClientStatus[ClientStatus.ClientNonMember]
  }

  isExClientNonMember(status: any): Boolean {
    let cltStatus = ClientStatus[status as keyof typeof ClientStatus];
    return cltStatus == ClientStatus.ExClientNonMember || status.toString() == ClientStatus[ClientStatus.ExClientNonMember]
  }

  hasAnyRelation(client: ClientById): boolean {
    if (!client) return false;
    return client.is_child || (client.childs && client.childs.length > 0);
  }

  setRelationDetails() {
    this.relationDetails = [];
    
    if(this.hasAnyRelation(this.client) && this.client.parent_client_id > 0) {
      // For parent client, make async call
      this.clientService.getClientByIdNew(this.client.parent_client_id).subscribe({
        next: (res: ClientById) => {
          this.parentClient = res;
          const details = {
            relation: this.client.relation, 
            relationImage: res.image, 
            relationName: res.full_name, 
            relationType: this.client.relation === 'Child' ? 'Parent' : this.client.relation
          };
          this.relationDetails = [details];
          this.cd.detectChanges();
        },
        error: (error: any) => {
          console.error('Error loading parent client data:', error);
        }
      });
    }
    else if(this.hasAnyRelation(this.client) && this.client.childs && this.client.childs.length > 0) {
      // For child clients, data is already available
      for(let child of this.client.childs) {
        this.relationDetails.push({
          relation: child.relation, 
          relationImage: child.image, 
          relationName: child.full_name, 
          relationType: child.relation
        });
      }
      this.cd.detectChanges();
    }
  }

  getRelationDetails(client: ClientById) {
    return this.relationDetails;
  }

  crownType(clientSince: string) {
    const ValidDate = new Date(this.timeService.ConvertUTCToLocalDateTime(clientSince));
    if (isNaN(ValidDate.getDate())) {
      return { crown: 'silver-crown', coin: 'less-spent-icon', color: 'text-400' };
    }
    if (this.isDefaultDate(clientSince)) {
      return { crown: 'default', coin: 'default', color: '' };
    }
    const duration = timeLineService(this.timeService.ConvertUTCToLocalDateTime(clientSince));
    if (
      duration.timeline == 'year' &&
      duration.value >= 1 &&
      duration.value < 3 &&
      duration.type == 'ago'
    ) {
      return { crown: 'bronze-crown', coin: 'medium-spent-icon', color: 'text-800' };
    } else if (
      duration.timeline == 'year' &&
      duration.value >= 3 &&
      duration.value < 5 &&
      duration.type == 'ago'
    ) {
      return { crown: 'silver-crown', coin: 'less-spent-icon', color: 'text-400' };
    } else if (
      duration.timeline == 'year' &&
      duration.value >= 5 &&
      duration.type == 'ago'
    ) {
      return { crown: 'gold-crown', coin: 'most-spent-icon', color: 'text-yellow-600' };
    } else {
      return { crown: 'default', coin: 'default', color: '' };
    }
  }

  get showSkeleton(): boolean {
    return this.showSkeleton$.value;
  }

  get clientDetails(): BehaviorSubject<ClientById> {
    return new BehaviorSubject<ClientById>(this.client);
  }

  changeInAction(e: any) {
    if(e && e.action) this.getClientDetails();
    this.changeEvent.emit(e);
  }

  closeSidebar() {
    this.closeClientSidebar.emit(true);
    this.cd.detectChanges();
  }

  ActiveTenant(client: any) {
    if (client.home_club_tenant_id && client.home_club_tenant_id > 0)
      return this.allTenants.find((o: { id: number; }) => o.id == client.home_club_tenant_id)!;
    else return this.allTenants.find((o: { id: number; }) => o.id == client.createdin_tenant_id)!;
  }

  getSalesRep(staffId: number) {
    return this.staffStoreService.getStaffById(staffId).pipe(map((staff) => {
      return staff;
    }));
  }

  GetReffferedBy(staffId: number) {
    return this.staffStoreService.getStaffById(staffId).pipe(map((staff) => {
      return staff;
    }));
  }

  getLanguage(code: string) {
    return CONSTANTS_DATA.ALL_LANGUAGES.find((lang) => (lang.LANG_CODE === code)) ? CONSTANTS_DATA.ALL_LANGUAGES.find((lang) => (lang.LANG_CODE === code))?.LANG_ABBRE : '';
  }

  toggleSendEmailDialog() {
    this.SelectedClient.next(this.client);
    this.toggleSendEmailDialog$.next(true);
  }

  closeSendEmailDialog(event: any) {
    this.toggleSendEmailDialog$.next(false);
    if (event && event.action && event.action == 'updated') this.getClientDetails();
    this.cd.detectChanges();
  }

  toggleCreateSmsDialog() {
    this.SelectedClient.next(this.client);
    this.toggleCreateSmsDialog$.next(true);
  }

  closeCreateSmsDialog(event: any) {
    this.toggleCreateSmsDialog$.next(false);
    if (event && event.action && event.action == 'updated') this.getClientDetails();
    this.cd.detectChanges();
  }

  toggleSendWhatsAppDialog() {
    this.SelectedClient.next(this.client);
    this.toggleSendWhatsAppDialog$.next(true);
  }

  closeSendWhatsAppDialog(e: any) {
    this.toggleSendWhatsAppDialog$.next(false);
    this.cd.detectChanges();
  }

  get isClientBlackListed() {
    return this.client && this.client.is_blacklisted;
  }

  CloseBookAppointment(event: any) {
    this.showBookAppointmentPopup = event;
  }
  
  reloadEvents(event: any) {
  }

copyToClipboard(text: string) {
  const textArea = document.createElement('textarea');
  textArea.value = text;
  document.body.appendChild(textArea);
  textArea.select();
  
  try {
      document.execCommand('copy');
      this.translate.get('common.message.COPY_SUCCESS').subscribe((message: string) => {
          this.toastMessageService.showSuccess(message);
      });
      document.body.removeChild(textArea);
  } catch (err) {
      this.toastMessageService.showError(err);
      document.body.removeChild(textArea);
  } finally {
      document.body.removeChild(textArea);
  }
}

getFlag(language: string){
  return CONSTANTS_DATA.ALL_LANGUAGES.find((lang) => (lang.LANG_CODE === language)) ? CONSTANTS_DATA.ALL_LANGUAGES.find((lang) => (lang.LANG_CODE === language))?.COUNTRY : '';
}

}
